var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWatsappicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.913,
    height: 20,
    viewBox: "0 0 19.913 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11571",
    "data-name": "Group 11571",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49424",
    "data-name": "Path 49424",
    d: "M.426,20a.426.426,0,0,1-.41-.538l1.3-4.748A9.917,9.917,0,1,1,10,19.836h0A9.937,9.937,0,0,1,5.4,18.709L.534,19.986A.428.428,0,0,1,.426,20Zm0,0",
    transform: "translate(0)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49425",
    "data-name": "Path 49425",
    d: "M10.9,30.044l1.346-4.917a9.492,9.492,0,1,1,8.224,4.752h0a9.483,9.483,0,0,1-4.535-1.155Zm5.264-3.037.288.171a7.878,7.878,0,0,0,4.015,1.1h0a7.888,7.888,0,1,0-6.683-3.7l.188.3-.8,2.91Zm0,0",
    transform: "translate(-10.469 -10.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49426",
    "data-name": "Path 49426",
    d: "M19.344,37.869l1.3-4.747a9.163,9.163,0,1,1,7.94,4.588h0A9.161,9.161,0,0,1,24.2,36.6Zm0,0",
    transform: "translate(-18.588 -18.626)",
    fill: "#64b161"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11570",
    "data-name": "Group 11570",
    transform: "translate(0.426 0.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49427",
    "data-name": "Path 49427",
    d: "M10.9,30.044l1.346-4.917a9.492,9.492,0,1,1,8.224,4.752h0a9.483,9.483,0,0,1-4.535-1.155Zm5.264-3.037.288.171a7.878,7.878,0,0,0,4.015,1.1h0a7.888,7.888,0,1,0-6.683-3.7l.188.3-.8,2.91Zm0,0",
    transform: "translate(-10.895 -10.895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49428",
    "data-name": "Path 49428",
    d: "M134.9,142.028c-.178-.395-.365-.4-.534-.41-.138-.006-.3-.006-.454-.006a.872.872,0,0,0-.632.3,2.658,2.658,0,0,0-.83,1.978,4.613,4.613,0,0,0,.968,2.453,9.734,9.734,0,0,0,4.051,3.58c2,.79,2.411.633,2.846.593a2.4,2.4,0,0,0,1.6-1.128,1.98,1.98,0,0,0,.138-1.128c-.059-.1-.217-.158-.455-.277s-1.4-.692-1.621-.771-.376-.119-.534.119-.612.771-.751.929-.277.178-.514.06a6.485,6.485,0,0,1-1.907-1.177,7.145,7.145,0,0,1-1.319-1.642c-.138-.237,0-.354.1-.484a7.145,7.145,0,0,0,.593-.811.437.437,0,0,0-.02-.415C135.567,143.67,135.106,142.5,134.9,142.028Zm0,0",
    transform: "translate(-127.697 -136.507)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatsappicon);
export default __webpack_public_path__ + "static/media/watsappicon.01ed3eef49b86cf311ee79881193396e.svg";
export { ForwardRef as ReactComponent };